/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaUiAStopIcon16Light } from './MediaUiAStopIcon16Light';
import { MediaUiAStopIcon16Regular } from './MediaUiAStopIcon16Regular';
import { MediaUiAStopIcon16Solid } from './MediaUiAStopIcon16Solid';
import { MediaUiAStopIcon20Light } from './MediaUiAStopIcon20Light';
import { MediaUiAStopIcon20Regular } from './MediaUiAStopIcon20Regular';
import { MediaUiAStopIcon20Solid } from './MediaUiAStopIcon20Solid';
import { MediaUiAStopIcon24Regular } from './MediaUiAStopIcon24Regular';
import { MediaUiAStopIcon24Solid } from './MediaUiAStopIcon24Solid';
import { MediaUiAStopIcon32Regular } from './MediaUiAStopIcon32Regular';
import { MediaUiAStopIcon64Regular } from './MediaUiAStopIcon64Regular';
var sizes = {
    16: {
        light: MediaUiAStopIcon16Light,
        regular: MediaUiAStopIcon16Regular,
        solid: MediaUiAStopIcon16Solid,
    },
    20: {
        light: MediaUiAStopIcon20Light,
        regular: MediaUiAStopIcon20Regular,
        solid: MediaUiAStopIcon20Solid,
    },
    24: {
        regular: MediaUiAStopIcon24Regular,
        solid: MediaUiAStopIcon24Solid,
    },
    32: {
        regular: MediaUiAStopIcon32Regular,
    },
    64: {
        regular: MediaUiAStopIcon64Regular,
    },
};
export var MediaUiAStopIcon = forwardRef('MediaUiAStopIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
